import { render, staticRenderFns } from "./LastTotalEmissions.vue?vue&type=template&id=5e583c3e&"
import script from "./LastTotalEmissions.vue?vue&type=script&lang=js&"
export * from "./LastTotalEmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports